/* Trendy · Vista previa de colores (16-10-2026). Un solo archivo, sin librerías y sin almacenamiento.
   1) Ventana "Vista previa de colores" de la ficha (sections/trendy-ficha, ajuste vista_popup): <dialog> (hoja en el
      celular, diálogo en la compu). Arriba el MODELO, que es lo que se compra: elegirlo hace click en la tarjeta real
      [data-tf-variant], así cambian #tl-form [name=id], ?variant=, la hoja de compra (#tsb-sheet) y Releasit como siempre.
      Abajo los COLORES: carrusel con imán + chips. Son solo para mirar: no tocan formulario, URL, carrito ni almacenamiento.
      Pagar = cerrar y tocar el botón real (por la hoja de trendy-sticky.js si está montada: window.trendyHoja.pagar).
   2) Banner reutilizable (sections/trendy-vista-banner): el mismo carrusel; el modelo solo cambia la vista y el link.
   Animaciones: solo transform y opacity. Con prefers-reduced-motion o html.tr-lite: sin deslizamientos. */
(function () {
  'use strict';
  if (window.__tfv) return;
  window.__tfv = 1;
  var W = window, d = document, H = d.documentElement;
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function quieto() { return (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches) || H.classList.contains('tr-lite'); }
  function libre(f) { if (W.requestIdleCallback) W.requestIdleCallback(f, { timeout: 1500 }); else setTimeout(f, 250); }
  function cargar(img, alta) {
    if (!img || !img.hasAttribute('data-src')) return;
    if (alta) img.setAttribute('fetchpriority', 'high');
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
  }
  function plata(c) {
    var n = Math.round(Number(c) || 0), e = Math.floor(n / 100), r = n % 100;
    return '$' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (r ? ',' + (r < 10 ? '0' : '') + r : '');
  }
  /* flechas, Inicio y Fin dentro de un grupo de radios */
  function tecla(e, n, i) {
    var k = e.key;
    if (k === 'ArrowRight' || k === 'ArrowDown') return (i + 1) % n;
    if (k === 'ArrowLeft' || k === 'ArrowUp') return (i - 1 + n) % n;
    if (k === 'Home') return 0;
    if (k === 'End') return n - 1;
    return -1;
  }
  function radios(lista, i) { lista.forEach(function (b, k) { var on = k === i; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; }); }

  /* ── carrusel finito con imán (scroll-snap). Índice = scrollLeft / paso, leído en requestAnimationFrame. ── */
  function Carrusel(set, avisar) {
    var track = set.querySelector('[data-tfv-track]'), sl = qa('.tfv__sl', track), n = sl.length;
    var idx = -1, paso = 0, raf = 0, objetivo = -1, tObj = 0, self = this;
    function medir() { paso = n > 1 ? sl[1].offsetLeft - sl[0].offsetLeft : 0; }
    function poner(i) {
      idx = i;
      sl.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (sl[i]) cargar(sl[i].querySelector('img'), true);
      libre(function () { [idx - 1, idx + 1].forEach(function (k) { if (sl[k]) cargar(sl[k].querySelector('img')); }); });
      if (avisar) avisar(i, sl[i] ? sl[i].getAttribute('data-n') || '' : '');
    }
    function leer() {
      raf = 0;
      if (!paso) medir();
      if (!paso) return;
      var i = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / paso)));
      if (objetivo > -1) { if (i !== objetivo) return; objetivo = -1; }   /* deslizamiento pedido: no marcar los colores del medio */
      if (i !== idx) poner(i);
    }
    function soltar() { objetivo = -1; }
    this.n = n;
    this.indice = function () { return idx; };
    this.nombre = function () { return sl[idx] ? sl[idx].getAttribute('data-n') || '' : ''; };
    this.ir = function (i, suave) {
      i = Math.max(0, Math.min(n - 1, i));
      medir();
      if (i !== idx) poner(i);
      var x = i * paso;
      if (Math.abs(track.scrollLeft - x) < 2) return;
      if (suave && !quieto() && 'scrollBehavior' in H.style) {
        objetivo = i; clearTimeout(tObj); tObj = setTimeout(soltar, 900);
        track.scrollTo({ left: x, behavior: 'smooth' });
      } else { objetivo = -1; track.scrollLeft = x; }
    };
    this.activar = function (i) { medir(); self.ir(i == null ? Math.max(0, idx) : i, false); };
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(leer); }, { passive: true });
    track.addEventListener('pointerdown', soltar, { passive: true });
    track.addEventListener('click', function (e) { var k = sl.indexOf(e.target.closest('.tfv__sl')); if (k > -1 && k !== idx) self.ir(k, true); });
    if ('ResizeObserver' in W) new ResizeObserver(function () { if (!track.clientWidth || idx < 0) return; medir(); objetivo = -1; track.scrollLeft = idx * paso; }).observe(track);
  }

  /* conjuntos de fotos por modelo (uno visible): carrusel + chips + "Viendo:" + flechas */
  function armar(cont, alCambiar) {
    var sets = {}, ids = [];
    var prev = cont.querySelector('[data-tfv-prev]'), next = cont.querySelector('[data-tfv-next]'), nomEl = cont.querySelector('[data-tfv-nombre]');
    var api = { sets: sets, ids: ids, actual: null };
    function flechas() {
      var o = api.actual; if (!o) return;
      var i = o.car.indice();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= o.car.n - 1;
    }
    qa('[data-tfv-set]', cont).forEach(function (set) {
      var id = set.getAttribute('data-tfv-set'), chips = cont.querySelector('[data-tfv-chips="' + id + '"]');
      var o = { id: id, set: set, chips: chips, cb: chips ? qa('[data-i]', chips) : [], ini: parseInt(set.getAttribute('data-ini'), 10) || 0 };
      o.car = new Carrusel(set, function (i, nombre) {
        radios(o.cb, i);
        if (api.actual === o) { if (nomEl) nomEl.textContent = nombre; flechas(); if (alCambiar) alCambiar(o, i); }
      });
      if (chips) {
        chips.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) o.car.ir(+b.getAttribute('data-i'), true); });
        chips.addEventListener('keydown', function (e) {
          var b = e.target.closest('[data-i]'); if (!b) return;
          var j = tecla(e, o.cb.length, +b.getAttribute('data-i')); if (j < 0) return;
          e.preventDefault(); o.car.ir(j, true); o.cb[j].focus();
        });
      }
      sets[id] = o; ids.push(id);
    });
    if (prev) prev.addEventListener('click', function () { if (api.actual) api.actual.car.ir(api.actual.car.indice() - 1, true); });
    if (next) next.addEventListener('click', function () { if (api.actual) api.actual.car.ir(api.actual.car.indice() + 1, true); });
    /* cambia el conjunto visible; "vivo" = ya se puede medir (ventana abierta o banner cerca de la pantalla) */
    api.mostrar = function (id, vivo, animar) {
      var o = sets[id] || sets[ids[0]];
      if (!o) return null;
      if (api.actual !== o) {
        api.actual = o;
        ids.forEach(function (k) { var x = sets[k], on = x === o; x.set.hidden = !on; if (x.chips) x.chips.hidden = !on; });
        if (animar && !quieto() && o.set.animate) o.set.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
      }
      if (vivo) o.car.activar(o.car.indice() < 0 ? o.ini : null);
      if (nomEl && o.car.indice() > -1) nomEl.textContent = o.car.nombre();
      flechas();
      return o;
    };
    return api;
  }

  /* ── 1) ventana de la ficha ─────────────────────────────── */
  function Popup(dlg) {
    var root = dlg.closest('[data-tl-root]') || d;
    var G = armar(dlg), mods = qa('[data-tfv-mod]', dlg);
    if (!G.ids.length) return;
    var abridor = null, empujado = false, pendiente = null, urlSesion = null, tPend = 0, bloq = false, abajoFondo = false;
    var precio = dlg.querySelector('[data-tfv-precio]'), lista = dlg.querySelector('[data-tfv-lista]'), mnom = dlg.querySelector('[data-tfv-mnom]');
    function realSel() { return root.querySelector('[data-tf-variant][aria-checked="true"]') || root.querySelector('[data-tf-variant]'); }
    function pie() {
      var m = realSel(); if (!m) return;
      var pr = +m.getAttribute('data-price'), li = +m.getAttribute('data-compare'), t = m.querySelector('.tl-pkn');
      if (precio) precio.textContent = plata(pr);
      if (lista) { lista.textContent = plata(li); lista.hidden = !(li > pr); }
      if (mnom) mnom.textContent = t ? '· ' + t.textContent.trim() : '';
    }
    function mostrar(id, animar) {
      var o = G.mostrar(id, dlg.open, animar);
      if (o) radios(mods, mods.map(function (m) { return m.getAttribute('data-tfv-mod'); }).indexOf(o.id));
      pie();
    }
    function elegir(id) {
      var real = root.querySelector('[data-tf-variant="' + id + '"]');
      if (real && real.getAttribute('aria-checked') !== 'true') { real.click(); urlSesion = location.href; }
      mostrar(id, true);
    }
    function bloquear() {
      if (bloq) return; bloq = true;
      var sb = W.innerWidth - H.clientWidth;   /* > 0 solo con barra clásica; con barras superpuestas no hay nada que compensar */
      if (sb > 0) { H.style.setProperty('--tfv-sb', sb + 'px'); H.classList.add('tfv-sb'); }
      H.classList.add('tfv-dlg');
    }
    function desbloquear() { if (!bloq) return; bloq = false; H.classList.remove('tfv-dlg', 'tfv-sb'); H.style.removeProperty('--tfv-sb'); }
    function empujar() { try { history.pushState(Object.assign({}, history.state || {}, { tfv: 1 }), ''); return true; } catch (x) { return false; } }
    function abrir(btn) {
      if (dlg.open || typeof dlg.showModal !== 'function') return;
      abridor = btn || d.activeElement;
      var m = realSel();
      mostrar(m ? m.getAttribute('data-tf-variant') : G.ids[0], false);
      mods.forEach(function (x) { cargar(x.querySelector('img')); });
      bloquear();
      try { dlg.showModal(); } catch (x) { desbloquear(); return; }
      empujado = empujar(); urlSesion = null;
      G.mostrar(G.actual.id, true, false);
      var f = dlg.querySelector('[data-tfv-mod][aria-checked="true"]') || dlg.querySelector('[data-tfv-cerrar]');
      if (f) try { f.focus({ preventScroll: true }); } catch (x) {}
    }
    function cerrar() { if (dlg.open) dlg.close(); }
    function correr() { clearTimeout(tPend); if (pendiente) { var f = pendiente; pendiente = null; setTimeout(f, 30); } }
    function irAlForm() { var t = root.querySelector('#tl-comprar'); if (t) t.scrollIntoView({ block: 'start', behavior: quieto() ? 'auto' : 'smooth' }); }
    function pagar(kind) {
      pendiente = function () {
        var api = W.trendyHoja;
        if (api && typeof api.pagar === 'function') { api.pagar(kind); return; }
        var b = root.querySelector(kind === 'cod' ? '[data-tl-cod]' : '[data-tl-online]');
        if (!b || b.disabled || (kind === 'cod' && !(W._rsi && W._rsi.form))) { irAlForm(); return; }
        b.click();
      };
      cerrar();
    }
    dlg.addEventListener('pointerdown', function (e) { abajoFondo = e.target === dlg; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { if (abajoFondo) cerrar(); return; }   /* toque en el fondo oscuro */
      var t = e.target.closest && e.target.closest('[data-tfv-mod],[data-tfv-cerrar],[data-tfv-pagar]');
      if (!t) return;
      if (t.hasAttribute('data-tfv-mod')) elegir(t.getAttribute('data-tfv-mod'));
      else if (t.hasAttribute('data-tfv-cerrar')) cerrar();
      else pagar(t.getAttribute('data-tfv-pagar'));
    });
    dlg.addEventListener('keydown', function (e) {
      var m = e.target.closest && e.target.closest('[data-tfv-mod]'); if (!m) return;
      var j = tecla(e, mods.length, mods.indexOf(m)); if (j < 0) return;
      e.preventDefault(); elegir(mods[j].getAttribute('data-tfv-mod')); mods[j].focus();
    });
    dlg.addEventListener('close', function () {
      desbloquear();
      var o = abridor; abridor = null;
      if (!pendiente && o && o.isConnected) requestAnimationFrame(function () { try { o.focus({ preventScroll: true }); } catch (x) {} });
      if (empujado) { empujado = false; clearTimeout(tPend); tPend = setTimeout(correr, 450); history.back(); return; }   /* el popstate corre lo pendiente */
      correr();
    });
    /* "Atrás" del celular cierra la ventana. Al volver, la URL queda con el modelo elegido adentro (?variant=). */
    W.addEventListener('popstate', function () {
      if (dlg.open && empujado) { empujado = false; dlg.close(); }
      if (urlSesion && urlSesion !== location.href) { try { history.replaceState(history.state, '', urlSesion); } catch (x) {} }
      urlSesion = null;
      correr();
    });
    /* disparadores: la pila de mini bolsas y la cuenta siguen al modelo elegido */
    function disparadores() {
      var m = realSel(), id = m ? m.getAttribute('data-tf-variant') : '', o = G.sets[id];
      qa('[data-tfv-pila] [data-m]', root).forEach(function (im) { im.hidden = im.getAttribute('data-m') !== id; });
      if (o) qa('[data-tfv-cuenta]', root).forEach(function (el) { el.textContent = o.car.n + ' colores del surtido · solo para mirar'; });
    }
    qa('[data-tfv-abrir="' + dlg.id + '"]', root).forEach(function (b) { b.addEventListener('click', function () { abrir(b); }); });
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-tf-variant]')) setTimeout(disparadores, 0); });
    W.addEventListener('pageshow', function () { if (!dlg.open) desbloquear(); setTimeout(disparadores, 0); });
    disparadores();
  }

  /* ── 2) banner ─────────────────────────────── */
  function Banner(bx) {
    var G = armar(bx), mods = qa('[data-tvb-mod]', bx), vivo = false;
    if (!G.ids.length) return;
    var cta = bx.querySelector('[data-tvb-cta]'), ctaM = bx.querySelector('[data-tvb-cta-m]');
    var precio = bx.querySelector('[data-tvb-precio]'), lista = bx.querySelector('[data-tvb-lista]');
    function mostrar(id, animar) {
      var o = G.mostrar(id, vivo, animar), k = o ? G.ids.indexOf(o.id) : -1, m = mods[k];
      radios(mods, k);
      if (!m) return;
      if (cta) { cta.href = cta.getAttribute('data-base') + '?variant=' + o.id; if (ctaM) ctaM.textContent = '· ' + (m.getAttribute('data-nombre') || ''); }
      var pr = +m.getAttribute('data-price'), li = +m.getAttribute('data-compare');
      if (precio && pr) precio.textContent = plata(pr);
      if (lista && pr) { lista.textContent = plata(li); lista.hidden = !(li > pr); }
    }
    bx.addEventListener('click', function (e) { var m = e.target.closest && e.target.closest('[data-tvb-mod]'); if (m) mostrar(m.getAttribute('data-tvb-mod'), true); });
    bx.addEventListener('keydown', function (e) {
      var m = e.target.closest && e.target.closest('[data-tvb-mod]'); if (!m) return;
      var j = tecla(e, mods.length, mods.indexOf(m)); if (j < 0) return;
      e.preventDefault(); mostrar(mods[j].getAttribute('data-tvb-mod'), true); mods[j].focus();
    });
    var ini = bx.querySelector('[data-tvb-mod][aria-checked="true"]');
    mostrar(ini ? ini.getAttribute('data-tvb-mod') : G.ids[0], false);
    function despertar() { if (vivo) return; vivo = true; G.mostrar(G.actual.id, true, false); }
    if ('IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); despertar(); } }, { rootMargin: '300px 0px' });
      io.observe(bx);
    } else despertar();
  }

  function iniciar() {
    qa('dialog[data-tfv]').forEach(function (x) { if (!x.__tfv) { x.__tfv = 1; Popup(x); } });
    qa('[data-tvb]').forEach(function (x) { if (!x.__tfv) { x.__tfv = 1; Banner(x); } });
  }
  /* una marca {tfv} que quedó de otra visita (recarga con la ventana abierta) no debe quedar colgada */
  try { if (history.state && history.state.tfv) { var st0 = Object.assign({}, history.state); delete st0.tfv; history.replaceState(st0, ''); } } catch (e) {}
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  d.addEventListener('shopify:section:load', iniciar);
})();
